import { Typography, Stack } from '@mui/material';
import { lightGrey } from '@styles/colors';

interface AssignedQuestionsTagsProps {
  relevantTags: { id: number; tag: string }[];
}

function AssignedQuestionsTags({ relevantTags }: AssignedQuestionsTagsProps) {
  return (
    <Stack
      spacing={1}
      direction="row"
      flexWrap="wrap"
      useFlexGap
      sx={{ mt: 1 }}
    >
      {relevantTags?.map((tag: { id: number; tag: string }) => (
        <Typography
          style={{
            backgroundColor: lightGrey,
            borderRadius: 5,
            color: 'black',
            padding: '3px 8px',
            fontSize: '12px',
          }}
        >
          {tag.tag}
        </Typography>
      ))}
    </Stack>
  );
}

export default AssignedQuestionsTags;
